module.exports = __webpack_public_path__ + "img/image01-right.78833dc5.png";